import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from "vue-axios";
import VueFriendlyIframe from 'vue-friendly-iframe';
import VueCarousel from 'vue-carousel'
import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faInstagram} from '@fortawesome/free-brands-svg-icons'
import * as VueGoogleMaps from 'vue2-google-maps'


library.add(fas);
library.add(faInstagram);
// import VueImageWall from 'vue-imagewall'

// Vue.use(VueImageWall);

Vue.use(VueGoogleMaps, {load: {key: 'AIzaSyA8mGMZsqVbfVlrkmD2WLhrESiv54FkI2A', libraries: 'places'}})
Vue.component('icon', FontAwesomeIcon);
Vue.use(VueCarousel);
Vue.use(VueFriendlyIframe);
Vue.use(VueAxios, axios);

import 'bootstrap'


window.$ = window.jQuery = require('jquery');
import Popper from 'vue-popperjs'
import {fas} from "@fortawesome/free-solid-svg-icons";
Vue.config.productionTip = false;
Vue.component('popper', Popper);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
